<template>
  <div class="cx-wizard-title cx-wizard">
    <div class="left">
      <div>
        <slot name="left">
          <cx-button flat v-if="canPrevious" icon="arrow_back" :iconSize="14" @click="previous">{{ previousText }}</cx-button>
        </slot>
      </div>
    </div>
    <div class="cx-wizard-title-text">
      <slot name="title">
        <div class="cx-wizard-title-text">{{ title }}</div>
      </slot>
    </div>
    <div class="right">
      <slot name="right">
        <div class="cx-wizard-close" v-if="canCancel">
          <cx-button flat icon="close" :iconSize="14" @click="cancel"/>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
import CxButton from '@/components/CxButton';
// Title component for the CxWizard
export default {
  name: 'CxwizardTitle',
  components: {
    CxButton,
  },
  data() {
    return {};
  },
  props: {
    title: String,
    previous: { type: Function, required: true },
    previousText: String,
    canPrevious: { type: Boolean, default: true },
    canCancel: { type: Boolean, default: true },
    cancel: {
      type: Function,
      default: () => {
      }
    },
  },
  computed: {},
  methods: {}
};
</script>

<style lang="less" scoped>
@import '../../common';

@CxWizardTitleFontSizeHeader: 14px;
.cx-wizard-title {
  display: flex;
  background-color: @inputBackground;
  padding: 20px;
  color: @textColor;
  align-items: center;
  text-align: left;
  border-radius: 10px 10px 0 0;
  min-width: 250px;

  .cx-wizard-close {
    display: flex;
    flex-direction: row;
    align-items: center;
    color: @textColorLowlight;

    .cx-button { display: flex; margin-right: 8px;}

    font-size: 12px;

    &:hover {
      cursor: pointer;

      span, div {
        color: @textColorHighlight !important;
      }
    }
  }


  .cx-wizard-title-icon-text {
    display: inline-block;
  }

  .left {
    flex: 0 0 100px;
  }

  .cx-wizard-title-text {
    flex: 1 1 auto;
    font-size: @CxWizardTitleFontSizeHeader;
    text-align: center;
    color: @textColorHighlight;
    font-weight: 400;
  }

  .right {
    .cx-wizard-close {
      justify-content: flex-end;
      margin-right: 0px;

      .cx-button { margin-right: 0px; }
    }

    flex: 0 0 100px;
  }
}

</style>